import { createFileRoute } from "@tanstack/react-router";
import { agentSubjectApiRoute } from "@/features/agent-subjects";

export const Route = createFileRoute("/api/internal/agents/subject")({
    ...agentSubjectApiRoute,
});
